"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoKeyParser = void 0;
const cryptography_1 = require("../../../cryptography");
const key_parser_1 = require("./key-parser");
/**
 * Auto key-parser, try to guess the encryption type from the content and use the properly one
 */
class AutoKeyParser {
    convertPEMToPrivateKey(content) {
        if (!content) {
            throw new Error("PEM content is required");
        }
        const keyParser = this.guessKeyParser(content);
        return keyParser.convertPEMToPrivateKey(content);
    }
    guessKeyParser(content) {
        // The exported PEM file of Secp256k1 will contains specific BEGIN EC PRIVATE KEY prefix
        if (content.toUpperCase().indexOf("EC PRIVATE KEY") > 0) {
            return key_parser_1.KeyParser.getInstance(cryptography_1.EncryptionType.Secp256k1);
        }
        else {
            // And for Ed25519 it would be simple BEGIN PRIVATE KEY
            return key_parser_1.KeyParser.getInstance(cryptography_1.EncryptionType.Ed25519);
        }
    }
}
exports.AutoKeyParser = AutoKeyParser;
